export enum AplDocumentTypes {
  SDC = 'APL_SDC', // selective distribution criteria
  TC = 'APL_TC', // terms and conditions
}

export interface IAplDocumentMeta {
  languageCode: string
  date: string
}

export interface IAplDocument {
  FileName: string
  Meta: string // json string
  Type: AplDocumentTypes.TC | AplDocumentTypes.SDC
  id: number
  PathToFile: string
}
